import { useApplicationDetails } from 'app/frontend/base/config/queries'
import UserApplicationDetails from 'app/frontend/base/pages/TeamDashboard/subpages/TeamApplicants/components/UserApplicationDetails'
import { useParams } from 'react-router-dom'

const SingleUserApplication = () => {
  const { applicationId } = useParams()
  const { data: applicationDetails, refetch } = useApplicationDetails(
    undefined,
    applicationId ? parseInt(applicationId) : undefined,
  )

  if (!applicationDetails) return <div>Application not found</div>

  return (
    <UserApplicationDetails
      application={applicationDetails}
      inUserProfile={true}
      recruitmentDetails={applicationDetails.teamRecruitmentDetails}
      teamReference={applicationDetails.teamReference}
      prefetchedApplicationDetails={applicationDetails}
      onRefetchApplicationDetails={refetch}
    />
  )
}

export default SingleUserApplication
